const routerPC = [
    {
      path: '*',
      redirect: '/'
    },
     {
        path: '/',
        name: 'home',
        component: resolve => require(['@/view/pc/home.vue'], resolve),
        meta: {
          title: '首页'
        }
      }, 
  ]


  export default routerPC


// WEBPACK FOOTER //
// ./src/router/routerPC.js